module.exports = __webpack_public_path__ + "static/media/29COICT7.f6a521bc.jpg";